import React, { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Form, Text } from "../../components";
import Localization from "../../localization";
import { useApi, useApp } from "../../hooks";
import { Constants } from "../../utils";
import { AuthApi } from "../../apis";
import { Flex } from "antd";

const fields = [
  {
    type: "email",
    name: ["data", "email"],
    label: Localization.general.email_address,
    placeholder: Localization.placeholder.your_email,
    rules: [{ type: "email", required: true }],
  },
];

const ForgotPassword = ({ onLoginClick = () => {}, onFinish = () => {} }) => {
  const [captcha, setCaptcha] = useState("");
  const { execute } = useApi();
  const formRef = useRef();
  const app = useApp();

  const forgotPassword = async () => {
    try {
      await formRef.current.validateFields();
      const { email } = formRef.current.getFieldValue("data");
      await execute(async () => AuthApi.forgotPassword({ email, captcha }));
      app.modal.success({
        title: Localization.general.reset_password,
        description: Localization.formatString(
          Localization.feedback.forgot_password_success,
          <Text level={"text"} type="secondary" children={email} weight={600} />
        ),
      });
      onFinish();
    } catch (error) {}
  };

  return (
    <div>
      <Flex vertical align="center" gap={"2em"}>
        <Form className="w-100" fields={fields} ref={formRef} />
        <ReCAPTCHA
          onChange={setCaptcha}
          sitekey={Constants.Project.reCAPTCHASitekey}
        />
      </Flex>
      <Form.Submit
        type="primary"
        disabled={!captcha}
        onClick={forgotPassword}
        className="w-100 m-30-t"
        title={Localization.forgot_password.btn}
      />
      <div className="text-align-center m-20-t">
        <Text
          underline
          level="link"
          weight={"600"}
          onClick={onLoginClick}
          className="text-align-center"
          children={Localization.forgot_password.footer_1}
        />
      </div>
    </div>
  );
};

export default ForgotPassword;
